import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export const createPasswordStateSelector = (state: RootState) =>
  state.createPassword;

export const createPasswordSelectors = {
  isLoading: createSelector(createPasswordStateSelector, s => s.isLoading),
  isError: createSelector(createPasswordStateSelector, s => s.isError),
  errorCode: createSelector(createPasswordStateSelector, s => s.errorCode),
  isSuccess: createSelector(createPasswordStateSelector, s => s.isSuccess),
  isUninitialized: createSelector(
    createPasswordStateSelector,
    s => s.isUninitialized,
  ),
  error: createSelector(createPasswordStateSelector, s => s.error),
  data: createSelector(createPasswordStateSelector, s => s.data),
  stepValues: createSelector(createPasswordStateSelector, s => s.stepValues),
  lastAction: createSelector(createPasswordStateSelector, s => s.lastAction),
  currentStep: createSelector(createPasswordStateSelector, s => s.currentStep),
  redirectError: createSelector(
    createPasswordStateSelector,
    s => s.redirectError,
  ),
};
